<mat-card class="default-card grid-all">
    <mat-card-header>
        <mat-card-title>{{ title }}</mat-card-title>
    </mat-card-header>
    <mat-card-content>
        <div class="container">
            <form [formGroup]="apiConfigurationConditionForm" class="form">
                <div class="form-container">
                    <div class="form-item">
                        <mat-form-field>
                            <mat-label>Nom</mat-label>
                            <input matInput type="text" formControlName="name" autocomplete="off" tabindex="1" />
                        </mat-form-field>
                    </div>
                    <div class="form-item">
                        <mat-form-field>
                            <mat-label>Description</mat-label>
                            <textarea
                                matInput
                                cdkTextareaAutosize
                                cdkAutosizeMinRows="3"
                                cdkAutosizeMaxRows="5"
                                formControlName="description"
                                autocomplete="off"
                                tabindex="2"></textarea>
                        </mat-form-field>
                    </div>
                    <div class="form-item">
                        <mat-form-field>
                            <mat-label>Type</mat-label>
                            <mat-select formControlName="conditionType" tabindex="3">
                                @for (conditionType of conditionsType; track conditionType) {
                                    <mat-option [value]="conditionType.value">
                                        {{ conditionType.name }}
                                    </mat-option>
                                }
                            </mat-select>
                        </mat-form-field>
                    </div>

                    @if (apiConfigurationConditionForm.get('conditionType').value === apiConditionType.HttpCode) {
                        <div class="form-item">
                            <mat-form-field>
                                <mat-label>Comparaison</mat-label>
                                <mat-select formControlName="comparaisonOperator">
                                    @for (comparaison of comparaisons; track comparaison) {
                                        <mat-option [value]="comparaison.value">
                                            {{ comparaison.name }}
                                        </mat-option>
                                    }
                                </mat-select>
                            </mat-form-field>
                        </div>
                        <div class="form-item">
                            <mat-form-field>
                                <mat-label>Code Http</mat-label>
                                <input matInput type="text" formControlName="httpCode" autocomplete="off" />
                            </mat-form-field>
                        </div>
                    }

                    @if (apiConfigurationConditionForm.get('conditionType').value === apiConditionType.Variable) {
                        <!-- <div class="form-item">
                            <mat-form-field>
                                <mat-label>Nom de variable</mat-label>
                                <input matInput type="text" formControlName="variableName" autocomplete="off" />
                            </mat-form-field>
                        </div> -->
                        <div class="form-item">
                            <mat-form-field>
                                <mat-label>Variable</mat-label>
                                <mat-select formControlName="variableName">
                                    @for (variable of responseVariables; track variable) {
                                        <mat-option [value]="variable.id">
                                            {{ variable.name }}
                                        </mat-option>
                                    }
                                </mat-select>
                            </mat-form-field>
                        </div>
                        <div class="form-item">
                            <mat-form-field>
                                <mat-label>Type</mat-label>
                                <mat-select formControlName="dataType">
                                    @for (dataType of datasType; track dataType) {
                                        <mat-option [value]="dataType.value">
                                            {{ dataType.name }}
                                        </mat-option>
                                    }
                                </mat-select>
                            </mat-form-field>
                        </div>
                        <div class="form-item">
                            <mat-form-field>
                                <mat-label>Comparaison</mat-label>
                                <mat-select formControlName="comparaisonOperator">
                                    @for (comparaison of comparaisons; track comparaison) {
                                        <mat-option [value]="comparaison.value">
                                            {{ comparaison.name }}
                                        </mat-option>
                                    }
                                </mat-select>
                            </mat-form-field>
                        </div>
                        <div class="form-item">
                            <mat-form-field>
                                <mat-label>Valeur</mat-label>
                                <input matInput type="text" formControlName="value" autocomplete="off" />
                            </mat-form-field>
                        </div>
                    }

                    @if (apiConfigurationConditionForm.get('conditionType').value === apiConditionType.Logical) {
                        <div class="form-item">
                            <mat-form-field>
                                <mat-label>Expression</mat-label>
                                <input
                                    matInput
                                    type="text"
                                    formControlName="expression"
                                    autocomplete="off"
                                    appNoFocusContextMenu
                                    (contextmenu)="$event.preventDefault(); onInputRightClick('expression', $event)" />
                            </mat-form-field>
                        </div>
                    }
                </div>
            </form>
        </div>
    </mat-card-content>
    <mat-card-actions>
        @if (data.readonly === true) {
            <button mat-raised-button class="accent-button" (click)="onCancel()">Ok</button>
        } @else {
            <button mat-stroked-button class="accent-button" (click)="onCancel()">Annuler</button>
            <button mat-raised-button class="accent-button" (click)="onConfirm()">Valider</button>
        }
    </mat-card-actions>
</mat-card>

<app-multi-level-context-menu
    [isRootNode]="true"
    [nodeData]="contextMenuItems"
    (onContextMenuItemClick)="handleMenuItemClick($event)"
    (onClosed)="CloseContextMenu()"></app-multi-level-context-menu>
